
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import MatchSimple from './matchSimple.vue'

export default {
props: {
roundInfo: Object,
leagueId:'',
leagueBasicInfo:{}
},
components: {
Flexbox,
FlexboxItem,
Divider,
XButton,
MatchSimple
},
mounted(){

this.reload();
},
methods: {
reload(){
this.title = this.genTitle();
this.groups = this.roundInfo.groups;
},
getRoundName (roundType, roundNum, roundTitle) {
var roundName = "--";

if(roundType=='cup_1'){
roundName = "决赛"
}
else if(roundType=='cup_2'){
roundName = "半决赛"
}
else if(roundType=='cup_4'){
roundName = "1/4决赛"
}
else if(roundType=='cup_8'){
roundName = "1/8决赛"
}
else if(roundType=='cup_16'){
roundName = "1/16决赛"
}
else if(roundType=='cup_32'){
roundName = "1/32决赛"
}
else if(roundType=='cup_64'){
roundName = "1/64决赛"
}
else if(roundType=='cup_128'){
roundName = "1/128决赛"
}
else if(roundType=='cup_team'||roundType=='league'){
roundName = "小组赛第"+roundNum+"轮"
}
else if(roundType== 'customized_rank_round'){
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3]+"-"+arr[2]+"名排位赛"
}
return roundName;
},
genTitle(){
var title = this.getRoundName(this.roundInfo.type,this.roundInfo.number,this.roundInfo.title);


return title
},
viewRoundDetail(){

this.$router.push({path:"/round_report", query:{roundTitle:this.title,leagueTitle:this.leagueBasicInfo.title,leagueId:this.leagueId,roundId:this.roundInfo.id}})
}
},
data () {
return {
title:" ",
groups:[]
}
},
watch: {
roundInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/roundCard.vue